import {iconTinySearchBlack} from "../../../../../../assets";
import {h} from "preact";
import s from "./term.module.css";
import {useAppContext, useBehavioralContext} from "../../../../../../contexts";
import {Link} from "preact-router";

const Term = (props) => {
    // Destructured props
    const {
        handleSearchBar,
        term = "default_term"
    } = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Checks for the service type label
    const serviceType =
        !term.serviceType ? null : (
            <span className={`${highContrast ? "!text-[#fecc31]" : ""}`}>
                &nbsp;em {term.serviceType}
            </span>
        );

    return (
        <Link
            href={`/${term.href}`}
            className={`${s.root} ${highContrast ? s.dmRoot : ""}`}
            onClick={() => handleSearchBar("isOpen", false)}
        >
            <img
                src={iconTinySearchBlack}
                alt="Search icon"
                className={`${s.searchIcon}`}
            />
            <p className={`${s.label}`}>
                {term.name}
                {serviceType}
            </p>
        </Link>
    )
}

export default Term;
